<h3>Add an Author</h3>
<hr />
<form (submit)="onAuthorAdd($event)">
  <div class="form-group">
    <label for="author">Author Full Name</label>
    <input
      [(ngModel)]="newAuthor"
      name="newAuthor"
      required
      type="text"
      class="form-control"
      id="author"
      aria-describedby="author"
      placeholder="Enter Author's Name"
    />
  </div>
  <button type="submit" class="btn btn-primary">Add author</button>
</form>

<div style="text-align: center">
  <author-svg></author-svg>
</div>
